
import { ActionIdEnum } from "src/app/core/enums/list-layout/action-id-enum";
import { ButtonIdEnum } from "src/app/core/enums/list-layout/button-id-enum";
import { ButtonTypeEnum } from "src/app/core/enums/list-layout/button-type-enum";
import { ColumnTypeEnum } from "src/app/core/enums/list-layout/column-type-enum";
import { GlobalComponent } from "src/app/global-component";
import { TableConfigurationModel } from "src/app/core/models/table/table-configuration.model";
import { SortByValuesModel } from "src/app/core/models/table/sort-by-values.model";
import { NgSelectListModel } from "src/app/core/models/ng-select-list.model";
import { SecurityOperations } from "src/app/core/security/security-operations";
import { TableRequisitionFilter } from "./table-requisition-filter-config-enum";
import { RequisitionStatus } from "src/app/core/enums/requisition-status-enum";
import { FilterPredicateEnum } from "src/app/core/enums/filter-predicate-enum";
import { ModelTypeEnum } from "src/app/core/enums/model-type-enum";
import { RequisitionViewAssigned } from "src/app/core/enums/requisition-view-assigned-enum";

export class RequisitionListConfig extends TableConfigurationModel {

    constructor() {
        super();
        this.canConfigBeSavedToServer = true;
        this.listTitle = "Requisition List";
        this.showReload = true;
        this.pageSizeFilter = [
            { pageSize: GlobalComponent.defaultPagingInfo.pageSize },
            { pageSize: 25 },
            { pageSize: 50 }
        ]
        this.columns = [
            {
                visible: 'true',
                order: 0,
                width: "15px",
                type: ColumnTypeEnum.CheckBox,
            },
            {

                dataFieldName: 'number',
                title: 'Requisition #',
                sortable: new SortByValuesModel,
                visible: 'true',
                order: 1,
                width: "180px",
                type: ColumnTypeEnum.PhotoModel,

                underTextDataFieldName: 'type',
                imageUrlLink: true
            },
            {
                dataFieldName: 'client',
                title: 'Client',
                sortable: new SortByValuesModel,
                visible: 'true',
                order: 2,
                width: "220px",
                type: ColumnTypeEnum.SubPhotoModel,
                subDataFieldName: 'fullName',
                underTextDataFieldName: 'email',
            },

            {
                dataFieldName: 'account',
                title: 'Contact',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 3,
                width: "180px",
                type: ColumnTypeEnum.SubPhotoModel,
                subDataFieldName: 'fullName',
                underTextDataFieldName: 'companyName'
            },
            {
                dataFieldName: 'createdBy',
                title: 'Created By',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 4,
                width: "180px",
                type: ColumnTypeEnum.SubPhotoModel,
                subDataFieldName: 'fullName',
                underTextDataFieldName: 'email'

            },
            {
                dataFieldName: 'modifiedDate',
                title: 'Last Modified',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 5,
                width: "120px",
                type: ColumnTypeEnum.Date,
            },
            {
                dataFieldName: 'status',
                title: 'Status',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 6,
                width: "105px",
                type: ColumnTypeEnum.StatusCustom,
                customStatusClass: {
                    type: undefined,
                    switchOptions: [
                        { case: `${RequisitionStatus.Draft}`, return: 'coloredTextArea purple' },
                        { case: `${RequisitionStatus.SignaturePending}`, return: 'coloredTextArea teal' },
                        { case: `${RequisitionStatus.Submitted}`, return: 'coloredTextArea blue' },
                        { case: `${RequisitionStatus.Processing}`, return: 'coloredTextArea orange' },
                        { case: `${RequisitionStatus.Completed}`, return: 'coloredTextArea green' },
                        { case: `${RequisitionStatus.Incompleted}`, return: 'coloredTextArea red' },
                        { case: undefined, return: 'coloredTextArea red' }
                    ]
                },
                customStatusText: {
                    type: undefined,
                    switchOptions: [
                        { case: `${RequisitionStatus.Draft}`, return: 'Draft' },
                        { case: `${RequisitionStatus.SignaturePending}`, return: 'Signature Pending' },
                        { case: `${RequisitionStatus.Submitted}`, return: 'Submitted' },
                        { case: `${RequisitionStatus.Processing}`, return: 'Processing' },
                        { case: `${RequisitionStatus.Completed}`, return: 'Completed' },
                        { case: `${RequisitionStatus.Incompleted}`, return: 'Incompleted' },
                        { case: undefined, return: 'Other' }
                    ]
                }
            },
            {
                dataFieldName: 'total',
                title: 'Total',
                visible: 'true',
                order: 7,
                width: "100px",
                type: ColumnTypeEnum.Amount,
            },
            {
                dataFieldName: 'matterNumber',
                title: 'Requisition Matter',
                visible: 'false',
                order: 8,
                width: "125px",
                type: ColumnTypeEnum.String,
            },
            {
                dataFieldName: 'client',
                title: 'Client Matter',
                sortable: new SortByValuesModel,
                visible: 'false',
                order: 9,
                width: "125px",
                type: ColumnTypeEnum.ValueInSubModel,
                subDataFieldName: 'matterNumber',
            },
            {
                dataFieldName: 'client',
                title: 'Client Phone Number',
                sortable: new SortByValuesModel,
                visible: 'false',
                order: 10,
                width: "175px",
                type: ColumnTypeEnum.ValueInSubModel,
                subDataFieldName: 'phoneNumber',
            },
            {
                dataFieldName: 'account',
                title: 'Contact Email',
                sortable: new SortByValuesModel,
                visible: 'false',
                order: 11,
                width: "175px",
                type: ColumnTypeEnum.ValueInSubModel,
                subDataFieldName: 'email',
            },
            {
                dataFieldName: 'account',
                title: 'Contact Phone Number',
                sortable: new SortByValuesModel,
                visible: 'false',
                order: 12,
                width: "175px",
                type: ColumnTypeEnum.ValueInSubModel,
                subDataFieldName: 'phoneNumber',
            },
            {
                dataFieldName: 'account',
                title: 'Contact Fax Number',
                sortable: new SortByValuesModel,
                visible: 'false',
                order: 13,
                width: "175px",
                type: ColumnTypeEnum.ValueInSubModel,
                subDataFieldName: 'faxNumber',
            },
            {
                dataFieldName: 'assignees',
                title: 'Assigned To',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 14,
                width: "180px",
                type: ColumnTypeEnum.AssigneeArray,
            },
            {
                title: 'Actions',
                visible: 'true',
                order: 15,
                width: "125px",
                type: ColumnTypeEnum.Action
            },
        ]
        this.searchbarFilter =
        {
            value: '',
            placeHolderText: "Search by number, matter, client or contact",
            filter: {
                sections: [
                    {
                        sectionTitle: "Requisition",

                        options: [
                            {
                                value: {
                                    value: '',
                                    dataField: 'MatterNumber',
                                    predicate: FilterPredicateEnum.Contains,
                                    modelType: ModelTypeEnum.RequisitionModel
                                },
                                isSelected: false,
                                text: "Matter Number"
                            },
                            {
                                value: {
                                    value: '',
                                    dataField: 'Number',
                                    predicate: FilterPredicateEnum.Contains,
                                    modelType: ModelTypeEnum.RequisitionModel
                                },
                                isSelected: false,
                                text: "Requisition #"
                            },
                            {
                                value: {
                                    value: '',
                                    dataField: 'Type',
                                    predicate: FilterPredicateEnum.Contains,
                                    modelType: ModelTypeEnum.RequisitionModel
                                },
                                isSelected: false,
                                text: "Requisition Type"
                            },
                            {
                                value: {
                                    value: '',
                                    dataField: 'FullName',
                                    predicate: FilterPredicateEnum.Contains,
                                    modelType: ModelTypeEnum.UserModel
                                },
                                isSelected: false,
                                text: "Created By"
                            },
                        ],
                    },
                    {
                        sectionTitle: "Client",

                        options: [
                            {
                                value: {
                                    value: '',
                                    dataField: 'FullName',
                                    predicate: FilterPredicateEnum.Contains,
                                    modelType: ModelTypeEnum.ClientModel
                                },
                                isSelected: false,
                                text: "Full Name"
                            },
                            {
                                value: {
                                    value: '',
                                    dataField: 'Name',
                                    predicate: FilterPredicateEnum.Contains,
                                    modelType: ModelTypeEnum.ClientModel
                                },
                                isSelected: false,
                                text: "First Name"
                            },
                            {
                                value: {
                                    value: '',
                                    dataField: 'LastName',
                                    predicate: FilterPredicateEnum.Contains,
                                    modelType: ModelTypeEnum.ClientModel
                                },
                                isSelected: false,
                                text: "Last Name"
                            },
                            {
                                value: {
                                    value: '',
                                    dataField: 'Email',
                                    predicate: FilterPredicateEnum.Contains,
                                    modelType: ModelTypeEnum.ClientModel
                                },
                                isSelected: false,
                                text: "Email"
                            },
                            {
                                value: {
                                    value: '',
                                    dataField: 'PhoneNumber',
                                    predicate: FilterPredicateEnum.Contains,
                                    modelType: ModelTypeEnum.ClientModel
                                },
                                isSelected: false,
                                text: "Phone Number"
                            },
                            {
                                value: {
                                    value: '',
                                    dataField: 'MatterNumber',
                                    predicate: FilterPredicateEnum.Contains,
                                    modelType: ModelTypeEnum.ClientModel
                                },
                                isSelected: false,
                                text: "Matter Number"
                            },
                        ],
                    },
                    {
                        sectionTitle: "Contact",

                        options: [
                            {
                                value: {
                                    value: '',
                                    dataField: 'FirstName',
                                    predicate: FilterPredicateEnum.Contains,
                                    modelType: ModelTypeEnum.ContactModel
                                },
                                isSelected: false,
                                text: "First Name"
                            },
                            {
                                value: {
                                    value: '',
                                    dataField: 'LastName',
                                    predicate: FilterPredicateEnum.Contains,
                                    modelType: ModelTypeEnum.ContactModel
                                },
                                isSelected: false,
                                text: "Last Name"
                            },
                            {
                                value: {
                                    value: '',
                                    dataField: 'CompanyName',
                                    predicate: FilterPredicateEnum.Contains,
                                    modelType: ModelTypeEnum.ContactModel
                                },
                                isSelected: false,
                                text: "Company Name"
                            },
                            {
                                value: {
                                    value: '',
                                    dataField: 'Email',
                                    predicate: FilterPredicateEnum.Contains,
                                    modelType: ModelTypeEnum.ContactModel
                                },
                                isSelected: false,
                                text: "Email"
                            },
                            {
                                value: {
                                    value: '',
                                    dataField: 'PhoneNumber',
                                    predicate: FilterPredicateEnum.Contains,
                                    modelType: ModelTypeEnum.ContactModel
                                },
                                isSelected: false,
                                text: "Phone Number"
                            },
                            {
                                value: {
                                    value: '',
                                    dataField: 'FaxNumber',
                                    predicate: FilterPredicateEnum.Contains,
                                    modelType: ModelTypeEnum.ContactModel
                                },
                                isSelected: false,
                                text: "Fax Number"
                            },
                        ],
                    },
                ],
                selectedOptions: []
            }
        }

        this.filters = [
            {
                label: TableRequisitionFilter.RequisitionAssigneeFilter,
                options: [
                    new NgSelectListModel(RequisitionViewAssigned.All, $localize`:@@:All requisitions`, undefined, undefined, true),
                    new NgSelectListModel(RequisitionViewAssigned.Mine, $localize`:@@:Only mine`, undefined),
                ],
                selectedOption: undefined,
                inDropdown: false,
                inHeading: false,
                inButton: false,
                inButtonArray: true,
            },
            {
                label: TableRequisitionFilter.RequisitionStatusFilter,
                options: [
                    new NgSelectListModel(undefined, $localize`:@@:All Statuses`, undefined, undefined, true),
                    new NgSelectListModel(RequisitionStatus.Draft, $localize`:@@:Draft`, undefined, "bx bx-shopping-bag"),
                    new NgSelectListModel(RequisitionStatus.SignaturePending, $localize`:@@:Signature Pending`, undefined, "bx bx-pencil"),
                    new NgSelectListModel(RequisitionStatus.Submitted, $localize`:@@:Submitted`, undefined, "bx bx-layer-plus"),
                    new NgSelectListModel(RequisitionStatus.Processing, $localize`:@@:Processing`, undefined, "bx bx-repeat"),
                    new NgSelectListModel(RequisitionStatus.Completed, $localize`:@@:Completed`, undefined, "bx bx-check-circle"),
                    new NgSelectListModel(RequisitionStatus.Incompleted, $localize`:@@:Incompleted`, undefined, "bx bx-error-alt"),
                ],
                selectedOption: undefined,
                inDropdown: false,
                inHeading: true,
                inButton: false,
            }
        ]

        this.actions = [
            {
                visible: SecurityOperations.requisition.requisitionUpdate,
                label: 'View',
                actionId: ActionIdEnum.View,
                icon: 'ri-eye-fill',
                inDropdown: true,
                inList: true,
                visibleOnValues: [`${RequisitionStatus.Completed}`, `${RequisitionStatus.Incompleted}`],
                dataFieldName: 'status'
            },
            {
                visible: SecurityOperations.requisition.requisitionUpdate,
                label: 'Edit',
                actionId: ActionIdEnum.Edit,
                icon: 'ri-edit-line',
                inDropdown: true,
                inList: true,
                visibleOnValues: [`${RequisitionStatus.Draft}`, `${RequisitionStatus.Submitted}`, `${RequisitionStatus.Processing}`, `${RequisitionStatus.SignaturePending}`],
                dataFieldName: 'status'
            },
            {
                visible: SecurityOperations.requisition.requisitionUpdate,
                label: 'Notes',
                actionId: ActionIdEnum.Notes,
                icon: 'ri-file-list-2-fill',
                inDropdown: true,
                inList: false,
                visibleOnValues: [`${RequisitionStatus.Submitted}`, `${RequisitionStatus.Processing}`, `${RequisitionStatus.Completed}`, `${RequisitionStatus.Incompleted}`],
                dataFieldName: 'status'
            },
            {
                visible: SecurityOperations.requisition.requisitionReadLimitedToScope && SecurityOperations.user.userReadLimitedToScope,
                label: 'Assignee Management',
                actionId: ActionIdEnum.AssigneeManagement,
                icon: 'ri-user-add-line',
                inDropdown: true,
                inList: true,
                visibleOnValues: [`${RequisitionStatus.Submitted}`, `${RequisitionStatus.Processing}`, `${RequisitionStatus.SignaturePending}`],
                dataFieldName: 'status'
            },
            {
                visible: SecurityOperations.requisition.requisitionDelete,
                label: 'Delete',
                actionId: ActionIdEnum.Delete,
                icon: 'ri-delete-bin-fill',
                inDropdown: true,
                inList: false,
                visibleOnValues: [`${RequisitionStatus.Draft}`],
                dataFieldName: 'status'
            },

        ]

        this.buttons = [
            {
                visible: 'true',
                label: "Create New",
                action: ButtonIdEnum.CreateNew,
                color: "btn-success",
                iconIsAfterLabel: false,
                icon: "ri-add-fill",
                type: ButtonTypeEnum.Default,
            },
            {
                visible: 'true',
                label: "Export",
                action: ButtonIdEnum.None,
                color: "btn-soft-info",
                iconIsAfterLabel: true,
                icon: "ri-more-2-fill",
                type: ButtonTypeEnum.Dropdown,
                actions: [
                    {
                        text: $localize`:@@Export_Excel:Export to Excel`,
                        value: `${ButtonIdEnum.ExportExcel}`,
                        color: 'btn-soft-primary',
                        visible: `true`
                    },
                    {
                        text: $localize`:@@Export_CSV:Export to CSV`,
                        value: `${ButtonIdEnum.ExportCSV}`,
                        color: 'btn-soft-primary',
                        visible: `true`
                    },
                ]
            },
            {
                visible: SecurityOperations.user.userReadLimitedToScope && SecurityOperations.requisition.requisitionReadLimitedToScope,
                label: 'Add Assignee(s)',
                iconIsAfterLabel: true,
                action: ButtonIdEnum.Assignee,
                color: "btn-secondary",
                icon: "ri-user-add-line",
                type: ButtonTypeEnum.CheckBoxSelected,
            },
            {
                visible: SecurityOperations.requisition.requisitionDelete,
                label: undefined,
                iconIsAfterLabel: true,
                action: ButtonIdEnum.Delete,
                color: "btn-primary",
                icon: "ri-delete-bin-fill",
                type: ButtonTypeEnum.CheckBoxSelected,
            }

        ]
    }
}